/**
 * @deprecated Use rewriteUrlNew(key, value, append = false) instead
 * @param queryParam
 * @param newValue
 */
export function rewriteUrl(queryParam, newValue) {
    let baseUrl = window.location.origin + window.location.pathname

    if (!(typeof newValue === 'string' || newValue instanceof String)) {
        newValue = JSON.stringify(newValue)
    }

    if ('URLSearchParams' in window) {
        //modern way
        let searchParams = new URLSearchParams(window.location.search)

        if (newValue.toString().trim().length > 0) {
            searchParams.set(queryParam, newValue)
        } else {
            searchParams.delete(queryParam)
        }

        let query = searchParams.toString()
        if (query.length > 0) {
            baseUrl += '?' + searchParams.toString()
        }
        window.history.pushState(this, '', baseUrl)
    } else {
        //polyfill
        let re = new RegExp('([?&])' + queryParam + '=.*?(&|$)', 'i')
        let separator = baseUrl.indexOf('?') !== -1 ? '&' : '?'
        if (baseUrl.match(re)) {
            baseUrl = baseUrl.replace(
                re,
                '$1' + queryParam + '=' + newValue + '$2',
            )
        } else {
            baseUrl = baseUrl + separator + queryParam + '=' + newValue
        }
        window.location = baseUrl
    }
}
